import { createStore } from 'vuex';
import * as auth from './modules/auth';
import watches from './modules/watches'; // Import the new module
import boutiques from './modules/boutiques'

const store = createStore({
  strict: true,
  modules: {
    auth,
    watches,
    boutiques,
  },
});

// Export the store
export default store;
